<!-- Loading State - Only show if needed for web fallback -->
<div *ngIf="!isLoaded && !isNativePlatform" class="loading-container">
  <div class="loading-spinner"></div>
  <p>Loading app...</p>
</div>

<!-- Debug Info (only show in development) -->
<!-- <div *ngIf="isLoaded && !environment.production" class="debug-info">
  <p>App loaded successfully</p>
  <p>Desktop: {{isDesktop}}</p>
  <p>Notifications supported: {{isNotificationsSupported}}</p>
</div> -->

<!-- Main Content -->
<div [class.loaded]="isLoaded">
  <!-- <button
    *ngIf="environment.shepherdExploreTour && !environment.production"
    type="button"
    class="shepherd-qa-reset"
    (click)="resetShepherdToursForQa()"
  >
    Reset tours (QA)
  </button> -->
  <!-- Desktop Header -->
  <!-- <app-header *ngIf="!isDesktop"></app-header> -->
  <!-- Mobile Header -->
  <!-- <app-header *ngIf="!isDesktop"></app-header> -->

  <!-- Main Content: pull-to-refresh on /home and /activities (see home.page and activities.component) -->
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>
  <!-- Desktop Footer -->
  <!-- <app-footer *ngIf="isDesktop"></app-footer> -->

  <!-- Mobile Footer -->
  <!-- <app-footer *ngIf="!isDesktop"></app-footer> -->
</div>

<style>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Arial, sans-serif;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #007bff;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 20px;
}

.debug-info {
  position: fixed;
  top: 10px;
  left: 10px;
  background: rgba(0,0,0,0.8);
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  z-index: 10000;
}

.notification-prompt {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  touch-action: manipulation;
}

.btn {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.enable-notifications-btn {
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
  touch-action: manipulation;
}

.enable-notifications-btn:hover {
  background: #0056b3;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
